/* This file is autogenerated, see readme.md for instructions */
import MobilePushSvgIcon from '@bloomreach/banana-theme/icons/mobile-push.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const MobilePushIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <MobilePushSvgIcon />
    </Icon>
  );
});

MobilePushIcon.displayName = 'MobilePushIcon';

export default MobilePushIcon;
